import * as React from 'react';
import { FC, SVGProps } from 'react';

export const ChevronLeftIcon: FC<SVGProps<SVGSVGElement>> = props => (
    <svg
        width={17}
        height={14}
        viewBox="0 0 17 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M16.4641 6.73041L1.46405 6.73041M1.46405 6.73041L7.88017 12.7304M1.46405 6.73041L7.88017 0.730409"
            stroke="currentColor"
            strokeWidth={2}
        />
    </svg>
);

export default ChevronLeftIcon;
